import { BrowserCacheLocation, LogLevel } from "@azure/msal-browser";

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

const keycloakConfig = {
  config: {
    realm: 'marketplace-seller',
    url: 'https://sso-marketplace-staging.fnacdarty.com/',
    clientId: 'front-sellers',
  },
  initOptions: {
    onLoad: 'check-sso',
  }
}


const ssoConfig = {
  auth: {
    clientId: 'a0a8ca96-9460-4613-8454-f65ebeda6cbb',
    authority: 'https://login.microsoftonline.com/ee736e01-987f-46aa-a144-79812f19df56',
    redirectUri: 'https://catalog-mp-staging.fnacdarty.com/'
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: isIE, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string) {
        // console.log(message);
      },
      logLevel: LogLevel.Verbose,
      piiLoggingEnabled: false
    }
  }

}

export const environment = {
  api_url: 'https://catalog-mp-staging.fnacdarty.com/api/',
  environment: 'rec2',
  datadog_env: 'rec2',
  keycloakConfig: keycloakConfig,
  msalConfig: ssoConfig,
  docsBucketUrl:'https://catalog-mp-staging.fnacdarty.com/medias/doc/',
  docApiServerUrl: 'https://catalog-mp-rec2-fd.fd-recette.net/'
};
